import React from 'react';
import Box from '@material-ui/core/Box';
import GridTextField from '../../components/GridTextField';
import Grid from '@material-ui/core/Grid';
import { FormContextValues } from 'react-hook-form';
import FormPeople from '../../types/FormPeople';
import { applyMaskOnChange, removeMaskIfBackspace } from '../../utils';

interface Props {
  form: FormContextValues<FormPeople>;
  open: boolean;
}

export default function PeopleTabAddress({
  form,
  open,
}: Props) {
  return (
    <Box hidden={!open}>
      <Grid container spacing={2}>
        <GridTextField
          label='Endereço'
          name='address.street'
          gridSize={8}
          inputRef={form.register}
        />
        <GridTextField
          label='Número'
          name='address.number'
          type='number'
          gridSize={4}
          inputRef={form.register}
          onChange={applyMaskOnChange('num')}
        />
        <GridTextField
          label='Complemento'
          name='address.complement'
          gridSize={8}
          inputRef={form.register}
        />
        <GridTextField
          label='CEP'
          name='address.zipCode'
          gridSize={4}
          inputRef={form.register}
          onKeyDown={removeMaskIfBackspace}
          onChange={applyMaskOnChange('cep')}
        />
        <GridTextField
          label='Bairro'
          name='address.neighborhood'
          gridSize={4}
          inputRef={form.register}
        />
        <GridTextField
          label='Cidade'
          name='address.city'
          gridSize={4}
          inputRef={form.register}
        />
        <GridTextField
          label='Estado'
          name='address.state'
          gridSize={4}
          inputRef={form.register}
        />
        <GridTextField
          label='Naturalidade'
          name='native'
          gridSize={4}
          inputRef={form.register}
        />
        <GridTextField
          label='Nacionalidade'
          name='nationality'
          gridSize={4}
          inputRef={form.register}
        />
      </Grid>
    </Box>
  );
}
